import { isNativeApp } from './platformUtils';

// Environment URL constants
export const ENVIRONMENTS = {
  PRODUCTION: import.meta.env.VITE_SITE_URL || 'https://thematmonster.com',
  DEVELOPMENT: 'http://localhost:8080',
  PREVIEW: typeof window !== 'undefined' ? window.location.origin : '',
};

/**
 * Returns the appropriate domain for different usage scenarios
 * @param forceProduction If true, always returns production URL regardless of environment
 * @returns String containing the appropriate domain
 */
export function getCurrentDomain(forceProduction: boolean = false): string {
  // For sharing and referral links, we typically want the production URL
  if (forceProduction) {
    return ENVIRONMENTS.PRODUCTION;
  }
  
  // If this is a native app, we still want to use the production URL for shareable content
  if (isNativeApp()) {
    return ENVIRONMENTS.PRODUCTION;
  }
  
  // Otherwise use the defined site URL if available, or fall back to current origin
  const productionUrl = import.meta.env.VITE_SITE_URL;
  
  if (productionUrl) {
    return productionUrl;
  }
  
  // Last resort fallback - current origin
  return typeof window !== 'undefined' ? window.location.origin : ENVIRONMENTS.DEVELOPMENT;
}
